import { UPDATE_ISSUE } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_ISSUE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_ISSUE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_ISSUE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
